const Profile = () => import ( /* webpackChunkName: "profile" */ './profile/Profile'),
  ProfileOrderHistory = () => import ( /* webpackChunkName: "profile" */ './profile/ProfileOrderHistory'),
  ProfileDefaultAddress = () => import ( /* webpackChunkName: "profile" */ './profile/ProfileDefaultAddress'),
  ProfilePaymentMethod = () => import ( /* webpackChunkName: "profile" */ './profile/ProfilePaymentMethod'),
  SignIn = () => import ( /* webpackChunkName: "account" */ './SignIn'),
  SignUp = () => import ( /* webpackChunkName: "account" */ './SignUp'),
  ForgotPassword = () => import ( /* webpackChunkName: "account" */ './ForgotPassword'),
  ResetPassword = () => import ( /* webpackChunkName: "account" */ './ResetPassword');

export default [{
  path: '/login',
  component: SignIn,
  name: 'signIn',
}, {
  path: '/register',
  component: SignUp,
  name: 'signUp',
}, {
  path: '/register/partner',
  component: SignUp,
  name: 'signUpPartner',
}, {
  path: '/forgot-password',
  component: ForgotPassword,
  name: 'forgotPassword',
}, {
  path: '/password-reset/:token',
  component: ResetPassword,
  name: 'resetPassword',
  props: true,
}, {
  path: '/my-account',
  name: 'profile',
  redirect: '/my-account/order-history',
  component: Profile,
  children: [{
    path: 'order-history',
    name: 'profileOrderHistory',
    component: ProfileOrderHistory,
  }, {
    path: 'default-address',
    name: 'profileDefaultAddress',
    component: ProfileDefaultAddress,
  }, {
    path: 'payment-method',
    name: 'profilePaymentMethod',
    component: ProfilePaymentMethod,
  }],
}];